import { render, staticRenderFns } from "./formquery.vue?vue&type=template&id=5a0896e9"
import script from "./formquery.vue?vue&type=script&lang=js"
export * from "./formquery.vue?vue&type=script&lang=js"
import style0 from "./formquery.vue?vue&type=style&index=0&id=5a0896e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports